module.exports = __webpack_public_path__ + "img/folder.76c401f4.svg";